export const CELL_RENDER_TYPE = {
	id: 'id',
	link: 'link',
	boolean: 'boolean',
	number: 'number',
	duration: 'duration',
	date: 'date',
	circle: 'circle',
};
